import client from '../../services/session/apiClient';

//TODO - only search endpoint has been tested
const reviewsAPI =  {
  getNetPromoterScore (params) {
    return client.get('/v5/netPromoterScore', { params })
      .then(response => response.data);
  },
  search (params) {
    return client
      .get('/v5/reviews', {params: Object.assign(params, {format: "original"})})
      .then(response => response.data);
  },
  getReviewsById (reviewIds) {
    return client
      .get(`/v5/reviews/findByIds`, {params: {format: "original", reviewIds}})
      .then(response => response.data);
  },
  snapshotSummary (groupId) {
    return client
      .get('/dashboard/reviewSummary/group/' + groupId)
      .then((response) =>  response.data);
  },
  averageReviewByState(groupId) {
    return client
      .get('/dashboard/stateSummary/group/' + groupId)
      .then((response) => response.data);
  },
  averageReviewByLocation(groupId) {
    return client
      .get('/dashboard/stateSummary/group/' + groupId)
      .then((resp) => resp.data);
  },
  generateReviewReport(params) {
    return client
      .get('/v5/reviews/report', { params })
      .then((response) => response.data);
  },
  exportReviews(params) {
    return client
      .post('/v5/reviews/export', {}, {params})
      .then(response => response.data);
  },
  exportComparisonData(params) {
    return client
      .post('/v5/reviews/comparisonReport/export', {}, {params})
      .then(response => response.data);
  },
  generateComparisonReport(params) {
    return client
      .get('/v5/reviews/comparisonReport', {params})
      .then(response => response.data);
  },
  locationsComparisonReport(groupId, params) {
    return client
      .get(`/v5/reviews/comparisonReport/${groupId}`, {params})
      .then(response => response.data);
  },
  locationComparisonReport(params) {
    return client
      .get('/v5/reviews/locationsComparisonReport', {params})
      .then(response => response.data);
  },
  markReviewNotMine(reviewId) {
    return client
      .post('/v5/reviews/' + reviewId + '/notMine', {reason: 'User requested removal'});
  },
  addReviewTag (reviewId, tag) {
    return client
      .post(`/v5/reviews/${reviewId}/tag`, tag);
  },
  removeReviewTag (reviewId, tagId) {
    return client
      .delete(`/v5/reviews/${reviewId}/tag/${tagId}`);
  },
  reaggregate(groupId) {
    return client
      .get(`/v5/reviews/reaggregate/${groupId}`);
  },
  submitReviewResponse(reviewId, detail, isPublic) {
    return reviewsAPI.submitReviewResponses([{reviewId, detail, isPublic}])
      .then(results => {
        if (results["errors"].length > 0) {
          throw results["errors"][0]
        }

        return results["succeeded"][0]
      })
  },
  submitReviewResponses(instructions) {
    return client
      .post(`/v5/reviews/responses`, {instructions})
      .then(response => response.data)
  },
  removeResponse(reviewId, responseId) {
    return client
      .delete(`/v5/reviews/${encodeURIComponent(reviewId)}/responses/${encodeURIComponent(responseId)}`)
  },

  generateReviewResponseTemplates(reviewId){
    return client
        .get(`/v5/reviews/responses/suggestions`, {params: {"reviewId": reviewId}})
        .then(response => response.data)
  }
};

export default reviewsAPI;
